/**
 * Fabpad collection page — filter chips, sort dropdown, load more.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-collection-section]');
    if (!root) return;

    var sectionId = root.dataset.sectionId;
    var grid = root.querySelector('[data-product-grid]');
    var countEl = root.querySelector('[data-product-count]');
    var paginationEl = root.querySelector('[data-pagination-info]');
    var filterEmpty = root.querySelector('[data-filter-empty]');
    var chips = root.querySelectorAll('[data-filter-chip]');
    var loadMoreBtn = root.querySelector('[data-load-more]');
    var sortToggle = root.querySelector('[data-sort-toggle]');
    var sortMenu = root.querySelector('[data-sort-menu]');
    var resetBtn = root.querySelector('[data-filter-reset]');
    var isPadsPackSort = root.dataset.padsPackSort === 'true';
    var isShopAll = root.dataset.shopAll === 'true';
    var activeCategory = 'all';
    var activeSubcat = '';
    var activeForceCategory = '';
    var subcatOptions = root.querySelectorAll('[data-all-subcat-option]');
    var sortLabelEl = root.querySelector('[data-sort-label]');
    var packSortOptions = root.querySelectorAll('[data-pack-sort-option]');
    var activePackSort = null;

    if (isShopAll && grid) {
      var seenHandles = {};
      grid.querySelectorAll('[data-collection-product]').forEach(function (item) {
        var key = item.dataset.productHandle || String(item.dataset.productId || '');
        if (!key) return;
        if (seenHandles[key]) {
          item.remove();
        } else {
          seenHandles[key] = true;
        }
      });
    }


    var totalProducts = parseInt(root.dataset.totalProducts || '0', 10);
    var loadedProducts = parseInt(root.dataset.loadedProducts || '0', 10);

    function getVisibleItems() {
      if (!grid) return [];
      return Array.prototype.filter.call(
        grid.querySelectorAll('[data-collection-product]'),
        function (item) {
          return !item.hidden;
        }
      );
    }

    function updateCount() {
      if (!countEl) return;
      var visible = getVisibleItems().length;
      countEl.textContent = visible + ' product' + (visible === 1 ? '' : 's');
      if (filterEmpty && grid) {
        var hasItems = grid.querySelectorAll('[data-collection-product]').length > 0;
        filterEmpty.hidden = !(hasItems && visible === 0);
      }
    }

    function updatePaginationInfo() {
      if (!paginationEl) return;
      var shown = grid ? grid.querySelectorAll('[data-collection-product]').length : loadedProducts;
      paginationEl.textContent = 'Showing ' + shown + ' of ' + totalProducts + ' products';
    }

    function setActiveChip(activeChip) {
      var tag = activeChip.dataset.filterTag || '';
      var category = activeChip.dataset.filterCategory || '';
      var isAll = activeChip.hasAttribute('data-filter-all');
      chips.forEach(function (chip) {
        var chipIsAll = chip.hasAttribute('data-filter-all');
        var chipTag = chip.dataset.filterTag || '';
        var chipCategory = chip.dataset.filterCategory || '';
        var same =
          (isAll && chipIsAll) ||
          (!isAll && category && chipCategory === category) ||
          (!isAll && !category && tag && chipTag === tag);
        chip.classList.toggle('is-active', same);
      });
    }

    function productHandle(item) {
      return (item.dataset.productHandle || '').toLowerCase();
    }

    function productTitle(item) {
      return (item.dataset.productTitle || '').toLowerCase();
    }

    function productMatchesCategory(item, category) {
      if (!category || category === 'all') return true;
      var cats = (item.dataset.navCategories || '').split(',').map(function (c) {
        return c.trim();
      }).filter(Boolean);
      return cats.indexOf(category) !== -1;
    }

    function updateSubcatMenu() {
      if (!isShopAll || !subcatOptions.length) return;
      var key = activeCategory || 'all';
      subcatOptions.forEach(function (option) {
        var allowed = (option.dataset.subcatCategories || 'all').split(',');
        var show = allowed.indexOf(key) !== -1 || allowed.indexOf('all') !== -1 && key === 'all';
        if (key !== 'all') {
          show = allowed.indexOf(key) !== -1;
        }
        option.hidden = !show;
      });
    }

    function updateShopAllSortLabel() {
      if (!isShopAll || !sortLabelEl) return;
      var activeOption = root.querySelector('[data-all-subcat-option].is-active');
      var label = activeOption ? activeOption.textContent.trim() : 'All';
      if (!activeSubcat) label = 'All';
      sortLabelEl.textContent = 'Subcategory: ' + label;
    }

    function setActiveSubcatOption(option) {
      subcatOptions.forEach(function (opt) {
        opt.classList.toggle('is-active', opt === option);
      });
    }

    function normalizeTag(str) {
      return (str || '').toLowerCase().trim().replace(/\s+/g, '-');
    }

    function productMatchesFilter(item, tag, categoryHint) {
      var tags = (item.dataset.tags || '').toLowerCase();
      var handle = (item.dataset.productHandle || '').toLowerCase();
      var title = (item.dataset.productTitle || '').toLowerCase();
      var needle = normalizeTag(tag);
      var category = categoryHint || '';
      var aliases = {
        'mid-waist': ['mid-waist', 'hipster'],
        'high-waist': ['high-waist'],
        'teen': ['teen'],
        'plus-size': ['plus-size'],
        'shorties': ['shorties'],
        'postpartum': ['postpartum'],
        'bonded': ['bonded'],
        'bladder-leaks': ['bladder-leaks'],
        'disposable': ['disposable']
      };
      var needles = aliases[needle] || [needle];

      if (needle === 'disposable') {
        if (
          handle.indexOf('sanitary') !== -1 ||
          handle.indexOf('cloth-pad') !== -1 ||
          handle.indexOf('pantyliner') !== -1 ||
          handle.indexOf('panty-liner') !== -1
        ) {
          return false;
        }
        if (handle.indexOf('reusable') !== -1 || title.indexOf('reusable') !== -1) {
          return false;
        }

        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'disposable';
        }) || handle.indexOf('disposable-period') !== -1
          || handle.indexOf('use-throw') !== -1
          || title.indexOf('disposable period') !== -1;
      }

      if (needle === 'reusable') {
        if (category === 'pads') {
          return handle.indexOf('cloth-pad') !== -1 || title.indexOf('cloth pad') !== -1;
        }
        if (category === 'liners') {
          return (handle.indexOf('pantyliner') !== -1 || handle.indexOf('panty-liner') !== -1) &&
            (handle.indexOf('cloth') !== -1 || handle.indexOf('reusable') !== -1);
        }
        if (tags.split(',').some(function (t) {
          return normalizeTag(t) === 'cotton-disposable';
        })) {
          return false;
        }

        if (handle.indexOf('disposable') !== -1 && handle.indexOf('reusable') === -1) {
          return false;
        }

        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'reusable';
        }) || handle.indexOf('reusable') !== -1
          || handle.indexOf('cloth-pad') !== -1
          || handle.indexOf('cloth-panty') !== -1
          || title.indexOf('cloth pad') !== -1
          || title.indexOf('reusable') !== -1;
      }

      if (needle === 'cotton-disposable') {
        if (category === 'pads') {
          return (
            handle.indexOf('pantyliner') === -1 &&
            handle.indexOf('panty-liner') === -1 &&
            handle.indexOf('cloth-pad') === -1 &&
            (handle.indexOf('sanitary') !== -1 || handle.indexOf('organic-cotton-disposable') !== -1)
          );
        }
        if (category === 'liners') {
          return (
            (handle.indexOf('pantyliner') !== -1 || handle.indexOf('panty-liner') !== -1) &&
            handle.indexOf('cloth') === -1 &&
            handle.indexOf('reusable') === -1
          );
        }
        if (tags.split(',').some(function (t) {
          return normalizeTag(t) === 'reusable';
        })) {
          return false;
        }

        if (handle.indexOf('reusable') !== -1 || handle.indexOf('cloth-pad') !== -1) {
          return false;
        }

        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'cotton-disposable';
        }) || handle.indexOf('disposable') !== -1
          || handle.indexOf('organic-cotton') !== -1
          || (handle.indexOf('pantyliner') !== -1 && handle.indexOf('cloth') === -1)
          || title.indexOf('disposable') !== -1
          || title.indexOf('organic cotton') !== -1;
      }

      if (needle === 'tampons') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'tampons';
        }) || (handle.indexOf('tampon') !== -1 && handle.indexOf('menstrual-cup') === -1)
          || (title.indexOf('tampon') !== -1 && title.indexOf('menstrual cup') === -1);
      }

      if (needle === 'menstrual-cup') {
        if (handle.indexOf('steriliz') !== -1 || title.indexOf('steriliz') !== -1) {
          return false;
        }

        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'menstrual-cup';
        }) || handle.indexOf('menstrual-cup') !== -1
          || title.indexOf('menstrual cup') !== -1
          || (handle.indexOf('cup') !== -1 && handle.indexOf('tampon') === -1 && title.indexOf('cup') !== -1);
      }

      if (needle === 'sterilizing-container') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'sterilizing-container';
        }) || handle.indexOf('steriliz') !== -1 || title.indexOf('steriliz') !== -1;
      }

      if (needle === 'with-applicator') {
        if (handle.indexOf('without-applicator') !== -1 || title.indexOf('without applicator') !== -1) {
          return false;
        }

        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'with-applicator';
        }) || handle.indexOf('applicator') !== -1 || title.indexOf('applicator') !== -1;
      }

      if (needle === 'without-applicator') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'without-applicator';
        }) || handle.indexOf('without-applicator') !== -1 || title.indexOf('without applicator') !== -1;
      }

      if (needle === 'bladder-leaks') {
        if (tags.split(',').some(function (t) {
          return normalizeTag(t) === 'bladder-leaks';
        })) {
          return true;
        }

        if (handle.indexOf('teen') !== -1 && handle.indexOf('urine') === -1 && handle.indexOf('incontinence') === -1) {
          return false;
        }

        return handle.indexOf('urine') !== -1
          || handle.indexOf('incontinence') !== -1
          || handle.indexOf('bladder') !== -1
          || title.indexOf('incontinence') !== -1
          || title.indexOf('bladder') !== -1;
      }

      if (needle === 'stand-and-pee') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'stand-and-pee';
        }) || handle.indexOf('stand-and-pee') !== -1
          || handle.indexOf('funnel') !== -1
          || title.indexOf('funnel') !== -1;
      }

      if (needle === 'intimate-wash') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'intimate-wash';
        }) || handle.indexOf('intimate-wash') !== -1 || title.indexOf('intimate wash') !== -1;
      }

      if (needle === 'intimate-wipes') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'intimate-wipes';
        }) || handle.indexOf('wipe') !== -1 || title.indexOf('wipe') !== -1;
      }

      if (needle === 'detergent') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'detergent';
        }) || handle.indexOf('detergent') !== -1
          || handle.indexOf('pad-wash') !== -1
          || title.indexOf('detergent') !== -1
          || title.indexOf('pad wash') !== -1;
      }

      if (needle === 'breast-pads') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'breast-pads';
        }) || handle.indexOf('breast') !== -1 || title.indexOf('breast') !== -1;
      }

      if (needle === 'sweat-pads') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'sweat-pads';
        }) || handle.indexOf('sweat') !== -1 || title.indexOf('sweat') !== -1;
      }

      if (needle === 'briefs') {
        if (handle.indexOf('trunk') !== -1) return false;
        if (
          handle.indexOf('period') !== -1 ||
          handle.indexOf('panty') !== -1 ||
          handle.indexOf('shorties') !== -1 ||
          handle.indexOf('bonded') !== -1
        ) {
          return false;
        }
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'briefs';
        }) || handle.indexOf('briefs') !== -1
          || handle.indexOf('fabpad-men') !== -1
          || handle.indexOf('mens-') !== -1
          || handle.indexOf('men-s') !== -1;
      }

      if (needle === 'trunks') {
        return tags.split(',').some(function (t) {
          return normalizeTag(t) === 'trunks';
        }) || handle.indexOf('trunk') !== -1 || title.indexOf('trunk') !== -1;
      }

      for (var i = 0; i < needles.length; i++) {
        var current = needles[i];
        if (tags.split(',').some(function (t) {
          var normalized = normalizeTag(t);
          return normalized === current;
        })) {
          return true;
        }

        if (handle.indexOf(current) !== -1 || title.indexOf(current.replace(/-/g, ' ')) !== -1) {
          return true;
        }

        if (current === 'mid-waist' && handle === 'reusable-period-panties') {
          return true;
        }
      }

      return false;
    }

    function getProductPackSize(item) {
      var handle = item.dataset.productHandle || '';
      var title = item.dataset.productTitle || '';
      var combined = (handle + ' ' + title).toLowerCase();
      var match = combined.match(/pack[- ]of[- ]?(\d+)/);
      if (match) return match[1];
      return '1';
    }

    function productMatchesPackSort(item, packSort) {
      if (!packSort || packSort === 'bestselling') return true;
      return getProductPackSize(item) === packSort;
    }

    function updateSortLabel() {
      if (!sortLabelEl) return;
      if (!activePackSort) {
        sortLabelEl.textContent = 'Sort';
        return;
      }
      if (activePackSort === 'bestselling') {
        sortLabelEl.textContent = 'Sort: Bestselling';
        return;
      }
      sortLabelEl.textContent = 'Sort: Pack of ' + activePackSort;
    }

    function setActivePackSortOption(value) {
      packSortOptions.forEach(function (option) {
        option.classList.toggle('is-active', option.dataset.packSortValue === value);
      });
    }

    function applyFilters(chip, options) {
      if (!grid) return;
      options = options || {};
      var tag = chip ? chip.dataset.filterTag || '' : '';
      var category = chip ? chip.dataset.filterCategory || '' : '';
      var isAll = chip ? chip.hasAttribute('data-filter-all') : false;
      var items = grid.querySelectorAll('[data-collection-product]');

      if (isShopAll && chip && !options.keepSubcat) {
        var nextCategory = isAll ? 'all' : category || activeCategory;
        if (nextCategory !== activeCategory) {
          activeCategory = nextCategory;
          activeSubcat = '';
          activeForceCategory = '';
          var resetSubcat = root.querySelector('[data-all-subcat-option][data-subcat=""]');
          if (resetSubcat) setActiveSubcatOption(resetSubcat);
        } else if (isAll) {
          activeCategory = 'all';
        } else if (category) {
          activeCategory = category;
        }
        updateSubcatMenu();
        updateShopAllSortLabel();
      }

      items.forEach(function (item) {
        var chipMatch = true;

        if (isShopAll) {
          var categoryMatch = true;
          var effectiveCategory = activeForceCategory || (activeCategory && activeCategory !== 'all' ? activeCategory : '');
          if (effectiveCategory) {
            categoryMatch = productMatchesCategory(item, effectiveCategory);
          }
          var subcatMatch = !activeSubcat || productMatchesFilter(item, activeSubcat, effectiveCategory);
          chipMatch = categoryMatch && subcatMatch;
        } else {
          chipMatch = isAll || (!tag && !category) || (tag && productMatchesFilter(item, tag));
        }

        var packMatch = productMatchesPackSort(item, activePackSort);
        item.hidden = !(chipMatch && packMatch);
      });

      if (chip) {
        setActiveChip(chip);
      } else if (tag) {
        chips.forEach(function (c) {
          c.classList.remove('is-active');
        });
      }

      updateCount();
    }

    function filterProducts(chip) {
      applyFilters(chip);
    }

    function filterByTag(tag) {
      if (!tag) return;
      var chip = root.querySelector('[data-filter-chip][data-filter-tag="' + tag + '"]');
      if (chip) {
        filterProducts(chip);
        return;
      }

      if (!grid) return;
      var items = grid.querySelectorAll('[data-collection-product]');
      items.forEach(function (item) {
        var chipMatch = productMatchesFilter(item, tag);
        var packMatch = productMatchesPackSort(item, activePackSort);
        item.hidden = !(chipMatch && packMatch);
      });
      chips.forEach(function (c) {
        c.classList.remove('is-active');
      });
      updateCount();
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        filterProducts(chip);
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        var allChip = root.querySelector('[data-filter-chip][data-filter-all]');
        if (allChip) filterProducts(allChip);
      });
    }

    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = !sortMenu.hidden;
        sortMenu.hidden = isOpen;
        sortToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });

      document.addEventListener('click', function () {
        sortMenu.hidden = true;
        sortToggle.setAttribute('aria-expanded', 'false');
      });

      sortMenu.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    if (isPadsPackSort && packSortOptions.length) {
      packSortOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          activePackSort = option.dataset.packSortValue || null;
          setActivePackSortOption(activePackSort);
          updateSortLabel();

          var activeChip = root.querySelector('[data-filter-chip].is-active');
          applyFilters(activeChip || null);

          if (sortMenu) {
            sortMenu.hidden = true;
          }
          if (sortToggle) {
            sortToggle.setAttribute('aria-expanded', 'false');
          }
        });
      });

      setActivePackSortOption(activePackSort || 'bestselling');
      if (!activePackSort) activePackSort = 'bestselling';
    }

    if (isShopAll && subcatOptions.length) {
      updateSubcatMenu();
      updateShopAllSortLabel();

      subcatOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          activeSubcat = option.dataset.subcat || '';
          activeForceCategory = option.dataset.forceCategory || '';
          setActiveSubcatOption(option);
          updateShopAllSortLabel();

          var activeChip = root.querySelector('[data-filter-chip].is-active');
          applyFilters(activeChip || null, { keepSubcat: true });

          if (sortMenu) {
            sortMenu.hidden = true;
            if (sortToggle) sortToggle.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }

    if (loadMoreBtn && grid) {
      loadMoreBtn.addEventListener('click', function () {
        var nextUrl = loadMoreBtn.dataset.nextUrl;
        if (!nextUrl) return;

        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = 'Loading…';

        var fetchUrl = nextUrl;
        if (fetchUrl.indexOf('section_id=') === -1) {
          fetchUrl += (fetchUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;
        }

        fetch(fetchUrl)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-product-grid]');
            if (newGrid) {
              newGrid.querySelectorAll('[data-collection-product]').forEach(function (item) {
                grid.appendChild(item);
              });
              loadedProducts = grid.querySelectorAll('[data-collection-product]').length;
              root.dataset.loadedProducts = String(loadedProducts);
            }

            var activeChip = root.querySelector('[data-filter-chip].is-active');
            applyFilters(activeChip || null, { keepSubcat: true });

            var newBtn = doc.querySelector('[data-load-more]');
            if (newBtn && newBtn.dataset.nextUrl) {
              loadMoreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
              loadMoreBtn.disabled = false;
              loadMoreBtn.textContent = 'Load more';
            } else {
              loadMoreBtn.remove();
            }

            updatePaginationInfo();

            if (window.FabpadProductCard && window.FabpadProductCard.init) {
              window.FabpadProductCard.init(grid);
            }
          })
          .catch(function () {
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Load more';
          });
      });
    }

    function initChipsScroller() {
      var wrap = root.querySelector('[data-chips-wrap]');
      if (!wrap) return;
      var scroller = wrap.querySelector('.fabpad-collection__chips-scroll');
      var nextBtn = wrap.querySelector('[data-chips-next]');
      var prevBtn = wrap.querySelector('[data-chips-prev]');
      if (!scroller || !nextBtn) return;

      function updateArrows() {
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var canScroll = maxScroll > 8;
        var atStart = scroller.scrollLeft <= 8;
        var atEnd = scroller.scrollLeft >= maxScroll - 8;
        nextBtn.hidden = !canScroll || atEnd;
        if (prevBtn) prevBtn.hidden = !canScroll || atStart;
        wrap.classList.toggle('is-overflow', canScroll);
        wrap.classList.toggle('is-scrolled', canScroll && !atStart);
      }

      nextBtn.addEventListener('click', function () {
        scroller.scrollBy({
          left: Math.max(Math.round(scroller.clientWidth * 0.7), 160),
          behavior: 'smooth'
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scroller.scrollBy({
            left: -Math.max(Math.round(scroller.clientWidth * 0.7), 160),
            behavior: 'smooth'
          });
        });
      }

      scroller.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      scroller.scrollLeft = 0;
      updateArrows();
    }

    initChipsScroller();

    var hashTag = (window.location.hash || '').replace(/^#/, '');
    var queryTag = new URLSearchParams(window.location.search).get('filter');
    var initialTag = queryTag || hashTag;
    if (initialTag) {
      filterByTag(initialTag);
    } else {
      updateCount();
    }

    updatePaginationInfo();
  });
})();
